import { Routes, Route } from 'react-router';
import NotFound from './common/components/NotFound';
import Login from './common/components/Login';

const CoreRoutes = () => (
    <Routes>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<NotFound />} />
    </Routes>
);
export default CoreRoutes;